export enum LiquidationPreferenceType {
  None = 'none',
  NonParticipating = 'nonParticipating',
}

export enum AntiDilutionRights {
  NarrowBased = 'narrowBased',
  None = 'none',
}

export enum CouponType {
  Cash = 'cash',
  None = 'none',
}

export enum MonitoringRights {
  ObserverRights = 'observerRights',
  None = 'none',
}

export enum HoldingClassType {
  Common = 'common',
  Preferred = 'preferred',
}
